import { useState } from 'react';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetActivityCodesAliases } from 'api/queries/getActivityCodesAliases.query';

import NoData from 'components/common/NoData/noData';
import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { CreateAlias } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/AliasPreferences/CreateAlias/createAlias';
import {
    columns,
    defaultColumn,
    initialState,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/AliasPreferences/aliasPreferences.utils';
import { Button } from 'components/DesignSystem/Button';

import classes from './aliasPreferences.module.scss';

export const AliasPreferences = () => {
    const [showCreateAliasModal, setShowCreateAliasModal] = useState<boolean>(false);

    const { contract } = useProjectTreeStore();
    const {
        data: activityCodesAliasesData,
        isLoading,
        isFetching,
    } = useQueryGetActivityCodesAliases({ contractId: contract?.id });

    const handleCreateAlias = () => {
        setShowCreateAliasModal(true);
    };

    const handleHideCreateAliasModal = () => {
        setShowCreateAliasModal(false);
    };

    return (
        <>
            <WidgetWithTitle
                title={'Activity Codes Alias'}
                titleComponents={[
                    <div className={classes.titleActions}>
                        <Button onClick={handleCreateAlias}>Add Alias</Button>
                    </div>,
                ]}
            >
                <div data-testid={'table-container'} className={classes.tableContainer}>
                    <MainTable
                        columns={columns}
                        data={activityCodesAliasesData?.aliasesList || []}
                        initialState={initialState}
                        defaultColumn={defaultColumn}
                        noData={<NoData>No alias mapping added yet. Click ‘Add Alias’ to add the first one.</NoData>}
                        isLoading={isLoading || isFetching}
                    />
                </div>
            </WidgetWithTitle>

            <CreateAlias
                showModal={showCreateAliasModal}
                onHideModal={handleHideCreateAliasModal}
                tableData={activityCodesAliasesData?.aliasesList}
            />
        </>
    );
};
